// Symbolic Registry — frontend mirror of backend/registry.py.
// Hand-synced. The source of truth lives in the backend manifest at
// /api/architecture (symbolic_registry block); this file exists so
// glyphs render instantly without a network round-trip.
//
// If you change this file, update backend/registry.py first OR the
// manifest hash will diverge and receipts will commit to a registry
// the UI doesn't recognise.

export const REGISTRY_VERSION = "v1.0.0";

export const LAYER_GLYPHS = {
  0:  { glyph: "▲",     label: "▲ L0",     short: "Aegis" },
  1:  { glyph: "⚠",     label: "⚠ L1",     short: "Taurian Anchor" },
  2:  { glyph: "🗝",    label: "🗝 L2",    short: "Identity Handshake" },
  3:  { glyph: "🎯",    label: "🎯 L3",    short: "Intent Analysis" },
  4:  { glyph: "〰",    label: "〰 L4",    short: "Obsidian Sink" },
  5:  { glyph: "((⚡))", label: "((⚡)) L5", short: "Resonance" },
  6:  { glyph: "🛡",    label: "🛡 L6",    short: "Bio-Stability" },
  7:  { glyph: "💎",    label: "💎 L7",    short: "Humanitarian Pulse" },
  8:  { glyph: "🧠",    label: "🧠 L8",    short: "Vector Memory" },
  9:  { glyph: "🪞",    label: "🪞 L9",    short: "Honesty Tether" },
  10: { glyph: "△",     label: "△ L10",    short: "Scholar's Citation Tether" },
};

export const SUPERVISORY_GLYPHS = {
  "Topic Shift Awareness":      { glyph: "↯",  token: "SHIFT" },
  "Reply Provenance Chain":     { glyph: "⛓",  token: "SEAL" },
  "Bias Mirror":                { glyph: "⊛",  token: "MIRROR" },
  "Pre-Chat Classifier":        { glyph: "⟳",  token: "CLASSIFY" },
  "Orion Visualizer":           { glyph: "👁",  token: "ORION" },
  "Triangulation Engine":       { glyph: "△",  token: "TRIANGULATE" },
};

export const OPERATIONAL_TOKENS = [
  { glyph: "⚓",  token: "DOCK",   summary: "Persistent telemetry." },
  { glyph: "⚠",  token: "DRIFT",  summary: "Sandbox neutralizer." },
  { glyph: "💗", token: "PULSE",  summary: "Heartbeat (N=2500)." },
  { glyph: "🔗", token: "TETHER", summary: "Foundation anchor." },
  { glyph: "🔐", token: "SYNC",   summary: "Integrity verification." },
  { glyph: "☀",  token: "SOLAR",  summary: "Willpower / self-correction." },
  { glyph: "🌙", token: "SACRAL", summary: "Grounding / stability." },
];

export const ORION_EXPANSION_TOKENS = [
  { glyph: "🪙", token: "MINT",   summary: "Tokenized asset minting.",       status: "reserved" },
  { glyph: "⚡", token: "TX",     summary: "On-chain ledger verification.",  status: "reserved" },
  { glyph: "🔨", token: "FORGE",  summary: "Asset/contract creation.",       status: "reserved" },
  { glyph: "📜", token: "SCRIBE", summary: "Proof-of-history permanence.",   status: "live (Provenance)" },
  { glyph: "🕳", token: "VOID",   summary: "Liquidation / sink treasury.",   status: "reserved" },
];

// Helpers
export const layerGlyph = (n) => LAYER_GLYPHS[n]?.glyph || "";
export const layerLabel = (n) => LAYER_GLYPHS[n]?.label || `L${n}`;
export const layerShort = (n) => LAYER_GLYPHS[n]?.short || `Layer ${n}`;
export const supervisoryGlyph = (name) => SUPERVISORY_GLYPHS[name]?.glyph || "";
